import React from "react";
import "./index.css";
import ReactDOM from "react-dom/client";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";

// Animation
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

// ---------------- Anti-Inspect / DevTools prevention ----------------
document.addEventListener('contextmenu', (e) => e.preventDefault());
document.addEventListener('keydown', (e) => {
  if (e.key === 'F12') e.preventDefault();
  if (e.ctrlKey && e.shiftKey && ['I', 'J'].includes(e.key.toUpperCase())) e.preventDefault();
  if (e.ctrlKey && e.key.toUpperCase() === 'U') e.preventDefault();
});

let devtools = { open: false };
const threshold = 160;
setInterval(() => {
  const widthThreshold = window.outerWidth - window.innerWidth > threshold;
  const heightThreshold = window.outerHeight - window.innerHeight > threshold;
  if (widthThreshold || heightThreshold) {
    if (!devtools.open) {
      devtools.open = true;
      alert('DevTools is not allowed on this site!');
    }
  } else {
    devtools.open = false;
  }
}, 1000);
// -------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
